/*
 * Copyright '2024' Dell Inc. or its subsidiaries. All Rights Reserved.
 */
export class RuntimeConfiguratorModuleLoadError extends Error {
    constructor(message: string) {
        super(message);
        this.name = 'RuntimeConfiguratorModuleLoadError';
    }
}
